'use client';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import type { SelectedEquipmentInfo } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { EQUIPMENT_IMAGE_PARAMS } from '../constants';
import { Image } from 'components/image';
import { getProductName } from '@cat-ecom/common/utils/stringUtils';
import { getFamilyName } from 'services/equipment/utils';
import { CatTextPassage, CatTooltip } from 'components/blocks-components';

export const SelectEquipmentDrawerEquipmentInfo = ({
  currentEquipment
}: {
  currentEquipment: SelectedEquipmentInfo;
}) => {
  const imageParams = EQUIPMENT_IMAGE_PARAMS;

  const familyName = getFamilyName(
    currentEquipment.model,
    currentEquipment.name ?? currentEquipment.productFamily
  );

  const equipmentName = `${currentEquipment.model} ${getProductName(familyName ?? '')}`;

  const { assetId, assetName } = currentEquipment;

  const displayEquipmentName = currentEquipment?.name
    ? currentEquipment.name
    : equipmentName;

  const renderTooltipBlock = (text: string) => (
    <CatTooltip position="auto">
      <CatHeading slot="trigger" variant="display-sm">
        <span className="text-truncate d-block" style={{ maxWidth: '216px' }}>
          {text}
        </span>
      </CatHeading>
      <CatTextPassage size="sm">{text}</CatTextPassage>
    </CatTooltip>
  );

  return (
    <div className="d-flex mt-3 mb-3 pb-1">
      <Image
        className="mb-0 me-3"
        height={60}
        width={80}
        alt={`${currentEquipment.model} ${currentEquipment.productFamily}`}
        src={
          (currentEquipment.imageURL || currentEquipment.imageUrl) &&
          `${currentEquipment.imageURL || currentEquipment.imageUrl}${imageParams}`
        }
      />
      <div>
        {assetId ? (
          <>
            {renderTooltipBlock(assetName || assetId)}
            <CatHeading variant="footnote">{displayEquipmentName}</CatHeading>
          </>
        ) : (
          renderTooltipBlock(displayEquipmentName)
        )}
        <CatHeading variant="footnote">
          {currentEquipment.serialNumber}
        </CatHeading>
      </div>
    </div>
  );
};
